//
// BooleanMetadata
//
// Based on view info from a layout

import { observer } from 'mobx-react-lite'
import { BooleanInput } from '../../../../components'

export const BooleanMetadata = observer(function BooleanMetadata({
    className,
    name,
    field,
    value,
    language,
    component,
    renderkey,
}) {
    let attributes = { className: 'layout-component ws-boolean' }
    if (className) attributes['className'] += ' ' + className
    if (component.style) attributes['className'] += ' lc-' + component.style

    return (
        <div {...attributes}>
            <BooleanInput value={value} />
            {name}
        </div>
    )
})
